(function() {
  'use strict';
  
  function initSearchModal() {
    // Buscar elementos
    const trigger = document.getElementById('dT_TopStickySearchBtn');
    const modal = document.querySelector('[data-search-modal]');
    const closeBtn = document.querySelector('[data-search-close]');
    const overlay = document.querySelector('[data-search-overlay]');
    const input = document.querySelector('[data-search-input]');
    const resetBtn = document.querySelector('[data-search-reset]');

    // Debug: verificar que encontramos los elementos
    console.log('Search Modal Debug:', {
      trigger: !!trigger,
      modal: !!modal,
      closeBtn: !!closeBtn,
      overlay: !!overlay,
      input: !!input,
      resetBtn: !!resetBtn
    });

    if (!trigger || !modal) {
      console.error('Search modal: Elementos no encontrados');
      return;
    }

    // Función para abrir modal
    function openModal() {
      console.log('Abriendo modal...');
      modal.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      setTimeout(() => {
        if (input) input.focus();
      }, 150);
    }

    // Función para cerrar modal
    function closeModal() {
      console.log('Cerrando modal...');
      modal.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    // Event: Click en trigger
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Trigger clicked');
      openModal();
    });

    // Event: Click en botón cerrar
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        closeModal();
      });
    }

    // Event: Click en overlay
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
          closeModal();
        }
      });
    }

    // Event: ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });

    // Event: Input change
    if (input && resetBtn) {
      input.addEventListener('input', function() {
        if (this.value.length > 0) {
          resetBtn.classList.remove('hidden');
        } else {
          resetBtn.classList.add('hidden');
        }
      });

      resetBtn.addEventListener('click', function(e) {
        e.preventDefault();
        input.value = '';
        resetBtn.classList.add('hidden');
        input.focus();
      });
    }

    console.log('Search modal initialized successfully');
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchModal);
  } else {
    initSearchModal();
  }

  // También intentar después de un delay por si acaso
  setTimeout(initSearchModal, 500);
})();